import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_NextBestAction_ActionFeedbackDataRequestModel,
  ResponseDataSystem_String,
  ResponseModels_NextBestAction_NextBestActionServiceLocationResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetServiceLocationNextBestActions = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  serviceLocationId: string;
  servingPointId?: number;
};
/**
 * Gets the NBAs for a ServiceLocation Id
 *
 * @returns ResponseModels_NextBestAction_NextBestActionServiceLocationResponseModel Success
 */
export function getServiceLocationNextBestActions(
  { businessUnit, label, serviceLocationId, servingPointId }: GetServiceLocationNextBestActions,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_NextBestAction_NextBestActionServiceLocationResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/servicelocation/${serviceLocationId}/nextbestactions`,
      query: { servingPointId },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetNextBestActionsForAddress = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  postalCode: string;
  houseNumber?: number;
  houseNumberSuffix?: string;
  servingPointId?: number;
};
/**
 * Gets the NBAs for Address
 *
 * @returns ResponseModels_NextBestAction_NextBestActionServiceLocationResponseModel Success
 */
export function getNextBestActionsForAddress(
  { businessUnit, label, postalCode, houseNumber, houseNumberSuffix, servingPointId }: GetNextBestActionsForAddress,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_NextBestAction_NextBestActionServiceLocationResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/servicelocation/nextbestactions`,
      query: { postalCode, houseNumber, houseNumberSuffix, servingPointId },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetServiceLocationId = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  postalCode: string;
  houseNumber: string;
  houseNumberSuffix?: string;
};
/**
 * Returns the ServiceLocationId based on the address
 *
 * @returns ResponseDataSystem_String Success
 */
export function getServiceLocationId(
  { businessUnit, label, postalCode, houseNumber, houseNumberSuffix }: GetServiceLocationId,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataSystem_String> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/servicelocation`,
      query: { postalCode, houseNumber, houseNumberSuffix },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type PutServiceLocationNextBestActionFeedback = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  serviceLocationId: string;
  requestBody: RequestModels_NextBestAction_ActionFeedbackDataRequestModel;
};
/**
 * Put Next Best Action Feedback for a service location (public)
 *
 * @returns any Success
 */
export function putServiceLocationNextBestActionFeedback(
  { businessUnit, label, serviceLocationId, requestBody }: PutServiceLocationNextBestActionFeedback,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/servicelocation/${serviceLocationId}/nextbestaction/feedback`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
